import BaseObject from "@shared/BaseObject.js";
import {LongitudinalClassId, LongitudinalRendererId} from "@shared/GenericTools/longitudinal/LongitudinalClassEnum.js";

export default class ToolDefinition extends BaseObject {
	toolType: string = ""
	slug: string = ""
	title: string = ""
	shortDescription: string = ""
	displaySummary: string = ""
	engine: string = ""
	participationMode: string = ""
	participationPolicy: any = null
	configRenderer: string = ""
	workRenderer: string = ""
	resultRenderer: string = ""
	blankPrintRenderer: string = ""
	resultPrintRenderer: string = ""
	resultBehavior: string = ""
	longitudinalClassId: string = LongitudinalClassId.HISTORY
	longitudinalRendererId: string = LongitudinalRendererId.HISTORY
	supportedSurfaces: string[] = []
	analyticsKey: string = ""
	searchKeywords: string[] = []
	defaultConfig: any = null
	publicDemoConfig: any = null
	warningContent: string = ""

	constructor(options = {}) {
		super(options);
		this.applyOptions(options)
	}

	supportsSurface(surface) {
		return this.supportedSurfaces.includes(surface)
	}

	matchesSearch(searchText = "") {
		let normalizedSearchText = searchText.trim().toLowerCase()
		let searchableText = [
			this.title,
			this.shortDescription,
			this.displaySummary,
			...this.searchKeywords,
		].join(" ").toLowerCase()
		return !normalizedSearchText || searchableText.includes(normalizedSearchText)
	}
}
